<template>
  <div id="lyruna">
    <transition-group name="langTrans" mode="out-in">
      <!-- --------------------- ENGLISH --------------------- -->
      <div v-if="english" class="inner" key="english">
        <div id="wrapper">
          <section id="main" class="wrapper">
            <div class="inner">
              <h1 class="major">
                NFT
                <span
                  class="lastname"
                  style="cursor: auto; border-bottom: none"
                >
                  Marketplace
                </span>
              </h1>
              <p>
                I searched for a cool mock-up to recreate in VueJS and i found
                <a
                  href="https://dribbble.com/shots/15662344-Lyruna-NFT-Marketplace-for-Musicians"
                  target="_blank"
                  rel="noreferrer noopener nofollow"
                  >this one</a
                >
                by Ryan Johnson. It's
                <a
                  href="https://github.com/Fraulk/nft-musician-marketplace"
                  target="_blank"
                  rel="noreferrer noopener nofollow"
                  >open source</a
                >.<br /><br />
                <a
                  href="https://nft-musician-marketplace.netlify.app/"
                  target="_blank"
                  rel="noreferrer noopener nofollow"
                  >Live Demo</a
                >
              </p>
            </div>
          </section>
        </div>
      </div>

      <!-- --------------------- FRENCH --------------------- -->
      <div v-if="!english" class="inner" key="french">
        <div id="wrapper">
          <section id="main" class="wrapper">
            <div class="inner">
              <h1 class="major">
                NFT
                <span
                  class="lastname"
                  style="cursor: auto; border-bottom: none"
                >
                  Marketplace
                </span>
              </h1>
              <p>
                J'ai cherché une maquette stylé à reproduire avec VueJS et j'ai
                trouvé
                <a
                  href="https://dribbble.com/shots/15662344-Lyruna-NFT-Marketplace-for-Musicians"
                  target="_blank"
                  rel="noreferrer noopener nofollow"
                  >celle-ci</a
                >
                de Ryan Johnson. C'est
                <a
                  href="https://github.com/Fraulk/nft-musician-marketplace"
                  target="_blank"
                  rel="noreferrer noopener nofollow"
                  >open source</a
                >.<br /><br />
                <a
                  href="https://nft-musician-marketplace.netlify.app"
                  target="_blank"
                  rel="noreferrer noopener nofollow"
                  >Live Demo</a
                >
              </p>
            </div>
          </section>
        </div>
      </div>
    </transition-group>
  </div>
</template>

<script>
export default {
  name: "WhoAmI",
  props: {
    english: Boolean,
  },
};
</script>